import React from "react";

const Chip = (props) => {
  const { label, selected = false, ...otherProps } = props;
  return (
    <div
      className={`${
        selected
          ? "text-white bg-[#EF4136] rounded-[25px] border border-[#ECECEC]"
          : "bg-[#F7F7F7] text-black rounded-[25px]"
      } px-4 py-2 rounded-full font-semibold transition-colors duration-200 cursor-pointer leading-6`}
      {...otherProps}
    >
      {label}
    </div>
  );
};

export default Chip;
